import { fetchGet } from '../helperApi'

export const fetchTickectDataApi = inspectionId => {
    return fetchGet(`ticket/${inspectionId}`)
}